import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdminPortalRole } from '../types/auth';

export function ProtectedRoute() {
  const { user, isAuthenticated, isLoading, logout } = useAuth();

  useEffect(() => {
    if (!isLoading && isAuthenticated && user && !isAdminPortalRole(user.role)) {
      logout();
    }
  }, [isLoading, isAuthenticated, user, logout]);

  if (isLoading) {
    return (
      <main className="loading-shell">
        <p>Loading…</p>
      </main>
    );
  }

  if (!isAuthenticated || !user || !isAdminPortalRole(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

/** Restricts nested routes to Super Admin only. */
export function SuperAdminRoute() {
  const { isSuperAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <main className="loading-shell">
        <p>Loading…</p>
      </main>
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
